(function () {
  function initReveal(section) {
    var nodes = section.querySelectorAll(".r, .rl, .rr, .rs");
    if (!nodes.length) return;

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (node) {
        node.classList.add("on");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, idx) {
          if (!entry.isIntersecting) return;
          setTimeout(function () {
            entry.target.classList.add("on");
          }, idx * 65);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.ffaReady === "true") return;
    section.dataset.ffaReady = "true";
    initReveal(section);
  }

  function bootAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll("[data-ffa-section]");
    sections.forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bootAll(document);
    });
  } else {
    bootAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    bootAll(event.target);
  });
})();
